import { Country } from '@axo/config/@types/Country.types';
import { BankIDNOButton } from '../../../bankId/ui/BankIDNOButton';
import { BankIDSEButton } from '../../../bankId/ui/BankIDSEButton';
import { CriiptoProvidersProps } from './criiptoProviderMapping';

const uiButtonMap: Partial<Record<Country, any>> = {
  NO: BankIDNOButton,
  SE: BankIDSEButton,
};

export const BankID = ({
  country,
  language,
  action,
  href,
  onClick,
}: CriiptoProvidersProps) => {
  const UiButton = uiButtonMap[country];

  if (!UiButton) {
    console.error(`Invalid country provided: country=${country}`);
    return null;
  }

  return (
    <UiButton
      action={action}
      language={language}
      href={href}
      onClick={onClick}
      data-testid="criipto-login"
      data-country={country}
    />
  );
};
